import { useState } from "react";
import Container from "../components/Container";
import ErrorMessageBlock from "../components/ErrorMessageBlock";
import Header from "../components/Header";
import InfoModal from "../components/InfoModal";
import UserDetailsForm from "../components/UserDetailsForm";
import EN from "../locales/en";
import withContentfulTag from "../utils/withContentfulTag";

const Home = ({ contentful }) => {
  const [termsModalOpen, setTermsModalOpen] = useState(false);
  const [showPageError, setShowPageError] = useState(false);
  return contentful ? (
    <>
      <Container>
        {showPageError && <ErrorMessageBlock />}
        <Header
          title={EN.home.title}
          subtitle={
            <div className="mt-4 max-w-4xl text-md leading-[1.5] text-center space-y-2">
              <span className="block">{EN.home.subtitle_1}</span>
              <span className="block">{EN.home.subtitle_2}</span>
            </div>
          }
        />
        <div className="mt-8">
          <UserDetailsForm setShowPageError={setShowPageError} />
        </div>
        <div className="mt-6">
          <p className="text-center text-xs leading-[20px] text-dark-gray">
            We share your information with third parties, which includes
            retrieving your current and previous energy information. By
            continuing you accept our{" "}
            <button
              className="text-primary underline"
              onClick={() => setTermsModalOpen(true)}
            >
              terms of use
            </button>
            , which includes confirming you have the bill payer's permission to
            access the data. Please see our{" "}
            <a
              href="https://loop.homes/policies/privacy-policy/"
              target="_blank"
              className="text-primary underline"
              rel="noopener noreferrer"
            >
              privacy policy
            </a>{" "}
            to understand how we will use your information to provide the
            service to you.
          </p>
        </div>
      </Container>

      <InfoModal
        open={termsModalOpen}
        setOpen={setTermsModalOpen}
        title={contentful?.title}
        body={contentful?.body}
        markdown={true}
      />
    </>
  ) : null;
};

export default withContentfulTag(Home, "switching_terms_of_use");
